/* tslint:disable */
/* eslint-disable */
/**
 * Umsatzcontrolling
 * Money
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  RsrImporteAusschnitt,
} from '../models/index';
import {
    RsrImporteAusschnittFromJSON,
    RsrImporteAusschnittToJSON,
} from '../models/index';

export interface RsrImporteRequest {
    seite: number;
    anzahl: number;
    filter: string;
}

/**
 * RsrImportApi - interface
 * 
 * @export
 * @interface RsrImportApiInterface
 */
export interface RsrImportApiInterface {
    /**
     * 
     * @summary Gibt eine Liste von RSR-Importen für den angegebenen RSQL-Filter zurück.
     * @param {number} seite Seitennummer bei mehreren Seiten.
     * @param {number} anzahl Gibt die Anzahl der Elemente pro Seite an.
     * @param {string} filter Gibt den RSQL-Filter für die gewünschten Elemente an.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RsrImportApiInterface
     */
    rsrImporteRaw(requestParameters: RsrImporteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RsrImporteAusschnitt>>;

    /**
     * Gibt eine Liste von RSR-Importen für den angegebenen RSQL-Filter zurück.
     */
    rsrImporte(requestParameters: RsrImporteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RsrImporteAusschnitt>;

}

/**
 * 
 */
export class RsrImportApi extends runtime.BaseAPI implements RsrImportApiInterface {

    /**
     * Gibt eine Liste von RSR-Importen für den angegebenen RSQL-Filter zurück.
     */
    async rsrImporteRaw(requestParameters: RsrImporteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RsrImporteAusschnitt>> {
        if (requestParameters.seite === null || requestParameters.seite === undefined) {
            throw new runtime.RequiredError('seite','Required parameter requestParameters.seite was null or undefined when calling rsrImporte.');
        }

        if (requestParameters.anzahl === null || requestParameters.anzahl === undefined) {
            throw new runtime.RequiredError('anzahl','Required parameter requestParameters.anzahl was null or undefined when calling rsrImporte.');
        }

        if (requestParameters.filter === null || requestParameters.filter === undefined) {
            throw new runtime.RequiredError('filter','Required parameter requestParameters.filter was null or undefined when calling rsrImporte.');
        }

        const queryParameters: any = {};

        if (requestParameters.seite !== undefined) {
            queryParameters['seite'] = requestParameters.seite;
        }

        if (requestParameters.anzahl !== undefined) {
            queryParameters['anzahl'] = requestParameters.anzahl;
        }

        if (requestParameters.filter !== undefined) {
            queryParameters['filter'] = requestParameters.filter;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_auth", []);
        }

        const response = await this.request({
            path: `/api/v1/allgemein/rsr`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RsrImporteAusschnittFromJSON(jsonValue));
    }

    /**
     * Gibt eine Liste von RSR-Importen für den angegebenen RSQL-Filter zurück.
     */
    async rsrImporte(requestParameters: RsrImporteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RsrImporteAusschnitt> {
        const response = await this.rsrImporteRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
